import angular from 'angular';
import ngCookies from 'angular-cookies';
import constants from 'app/constants';
import {
  assetDataService,
  reportsDataService,
  ssDialogService,
  loaderService
} from 'app/services';
import {
  alerts
} from 'app/components/global';
import controller from './bulk-delete-assets-dialog.controller';
import template from './bulk-delete-assets-dialog.html';
import bulkDeleteAssetsConfirmDialog from '../dialog.bulkDeleteAssetsConfirmDialog';


class dialogService {
  getOptions($event, { customerId, assetType }) {
    return {
      controller,
      controllerAs: 'bulkDeleteAssetsDialogVM',
      locals: {
        customerId,
        assetType
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.admin.asset.bulkDeleteAssetsDialog', [
  ngCookies,
  assetDataService,
  constants,
  reportsDataService,
  ssDialogService,
  alerts,
  loaderService,
  bulkDeleteAssetsConfirmDialog,
])
  .service('bulkDeleteAssetsDialog', dialogService)
  .name;
